module.exports = __webpack_public_path__ + "product_info-season_pass_uk.jpg";